// src/components/ProjectsSection.jsx
import React, { useRef, useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "../styles/ProjectSection.scss";

import img1 from "../assets/house_th.jpg";
import img2 from "../assets/tunelthing_ph.jpg";
import img3 from "../assets/panels_th.jpeg";
import img4 from "../assets/residence_th.jpg";
import img5 from "../assets/panels_2.jpeg";

const PROJECTS = [
  {
    title: "Aquecimento Solar Interno Completo",
    description:
      "Projeto completo com boiler para aquecimento de água interno.",
    img: img2,
  },
  {
    title: "Aquecimento Solar de Piscina",
    description: "Instalação de placas solares para água de piscina.",
    img: img1,
  },
  {
    title: "Aquecimento Para Banho",
    description: "Instalação de coletores solares de tubos à vácuo.",
    img: img3,
  },
  {
    title: "Aquecimento a Gás Residencial",
    description: "Instalação de unidade de aquecimento a gás para residência.",
    img: img4,
  },
  {
    title: "Projeto de Coletores Solares À Vácuo",
    description:
      "Utilização dos coletores em maior escala de distribuição interna.",
    img: img5,
  },
];

function ProjectItem({ project, index }) {
  const elRef = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry], observer) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    obs.observe(elRef.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={elRef}
      className={`project-item d-flex ${visible ? "visible" : ""}`}
      style={{ "--i": index }}
    >
      <img src={project.img} alt={project.title} className="slide-up" />
      <div className="text-content">
        <h4 className="pop-in">{project.title}</h4>
        <p className="pop-in">{project.description}</p>
      </div>
    </div>
  );
}

export default function ProjectsSection() {
  return (
    <section className="projects-section py-5">
      <Container>
        <Row>
          <Col md={4}>
            <div id="projects" className="project-stats text-center">
              <h2>Confira!</h2>
              <p>Projetos realizados</p>
              <p className="small-text">
                Boilers, placas solares e diversos outros sistemas de
                aquecimento...
              </p>
              <a
                href="https://wa.me/555391425203"
                target="_blank"
                style={{ color: "inherit" }}
              >
                <Button className="mt-2">Agende um atendimento!</Button>
              </a>
            </div>
          </Col>
          <Col md={8}>
            <div className="projects-list d-flex flex-column align-items-center">
              {PROJECTS.map((proj, idx) => (
                <ProjectItem key={idx} project={proj} index={idx} />
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
